<script setup lang="ts">
import { computed, inject, ref } from "vue";
import { nameInjectionKey } from "./../keys";
import { ValidationArgs, useVuelidate } from "@vuelidate/core";

const props = withDefaults(defineProps<{
    modelValue: string,
    hidePii?: boolean,
    placeholder?: string | null,
    class?: string | null,
    maxLength?: number | undefined,
    filter?: (e: KeyboardEvent) => boolean | undefined,
    id?: string,
    validation?: ValidationArgs,
}>(), {
    hidePii: true,
    filter: () => true,
    maxLength: 999,
    placeholder: undefined,
    class: "col-md-6",
    suggestions: undefined,
    id: undefined,
    validation: undefined,
});

const internalModelValue = computed(() => props.modelValue);

const v$ = useVuelidate({
    field: props.validation ?? {},
}, {
    field: internalModelValue,
});

const emit = defineEmits<{
    (on: "update:modelValue", value: string | number): void
    (on: "blur", value: string | number): void
}>();

const name = inject(nameInjectionKey);

if (typeof name !== "string") {
    throw new Error();
}

const inputRef = ref<HTMLTextAreaElement | null>(null);

</script>
<template>
    <div :class="props?.class">
        <textarea
            :id="id || name"
            ref="inputRef"
            :value="modelValue"
            :maxLength="maxLength"
            :class="[{
                input: true,
                sessioncamhidetext: hidePii,
                errorField: v$.$error,
            },
            ]"
            rows="2"
            class="form-control"
            :placeholder="placeholder || undefined"
            @keydown="props.filter"
            @input="emit('update:modelValue', ($event.target as HTMLInputElement).value)"
            @blur="v$.$touch()"
        />
    </div>
    <div
        v-if="v$.$error"
        class="field-validation-error"
    >
        <div class="alert alert-danger">
            {{ v$.$errors[0].$message }}
        </div>
    </div>
</template>
<style>
.error-margin {
    margin-top: 6px;
}
</style>
